export default "__VITE_ASSET__DkTGszdE__"